import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=24724243&"
import script from "./Pager.vue?vue&type=script&lang=ts&"
export * from "./Pager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24724243')) {
      api.createRecord('24724243', component.options)
    } else {
      api.reload('24724243', component.options)
    }
    module.hot.accept("./Pager.vue?vue&type=template&id=24724243&", function () {
      api.rerender('24724243', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pager.vue"
export default component.exports